import store from "../store";

export const hasAccess = (routeName) => {

    const role = store.getters.currentRole
    const currentUser = store.state.currentUser || null
    const provider = store.state.currentProvider

    if((!currentUser.active) && routeName === 'panel.account.activate') return true

    if(currentUser && !store.getters.isOnBoardingDone && routeName === 'panel.onboarding'){
        return true
    }

    if(currentUser && currentUser.account_type === 'provider' && provider && !role) return false
    //if(!role && routeName !== 'panel.dashboard' && routeName !== 'panel.account.activate') return false
    if(
        routeName === 'panel.provider.my_schedules'
        && provider && provider.institution
        && (role.is_owner || role.is_admin)) return false


    /*
    var providerRegex = new RegExp(/^panel.provider/g)
    if(provider && provider.is_owner && providerRegex.test(routeName)){
        return true
    }
    */

    var accessRules = getMergedRules()
    return accessRules.find(rule => routeName.includes(rule))

}

export const hasAccessToOffice = (officeId) => {

    const provider = store.state.currentProvider
    if(!provider || !provider.institution || !provider.role) return false

    var role = provider.role
    if(role.is_owner) return true

    var allScopes = role.scope.offices.find(office => office === '*') !== undefined
    if(allScopes) return true

    return role.scope.offices.find(office => office.toString() === officeId.toString()) !== undefined

}

export const  redirectToAuth = () => {

}

export const getMergedRules = () => {

    var currentUser = store.state.currentUser
    var currentProvider = store.state.currentProvider
    var userRules,  providerRules, allRules

    userRules = currentUser && currentUser.access_rules ? currentUser.access_rules : [];

    providerRules = currentProvider &&
        currentProvider.role &&
        currentProvider.role.access_rules ?
        currentProvider.role.access_rules : []

     allRules = userRules.concat(providerRules)
    var uniqueRules = allRules.filter((value, index, self) => {
        return self.indexOf(value) === index;
    })

    return uniqueRules

}
